<template>
  <!--
    < lg breakpoints (top banner) use `mobileImage` when set (falling back to
    the desktop image); >= lg breakpoints (the full-height side column) always
    use the desktop `image`. Heights/crops are unchanged from before.
  -->
  <SharedPicture
    :media="mobileImage || image"
    :loading="loading"
    :fetchpriority="fetchpriority"
    class="w-full h-full spotlight-image object-cover object-center !block sm:!hidden"
    :imageClass="imageClasses"
    height="200"
    width="375"
    :quality="90"
    @load="emit('load')"
  />
  <SharedPicture
    :media="mobileImage || image"
    :loading="loading"
    :fetchpriority="fetchpriority"
    class="w-full h-full spotlight-image object-cover object-center !hidden sm:!block md:!hidden"
    :imageClass="imageClasses"
    height="200"
    width="750"
    :quality="90"
    @load="emit('load')"
  />
  <SharedPicture
    :media="mobileImage || image"
    :loading="loading"
    :fetchpriority="fetchpriority"
    class="w-full h-full spotlight-image object-cover object-center !hidden md:!block lg:!hidden"
    :imageClass="imageClasses"
    height="460"
    width="800"
    :quality="90"
    @load="emit('load')"
  />
  <SharedPicture
    :media="image"
    :loading="loading"
    :fetchpriority="fetchpriority"
    class="w-full h-full spotlight-image object-cover object-center !hidden lg:!block xl:!hidden"
    :imageClass="imageClasses"
    height="1000"
    width="640"
    :quality="90"
    @load="emit('load')"
  />
  <SharedPicture
    :media="image"
    :loading="loading"
    :fetchpriority="fetchpriority"
    class="w-full h-full spotlight-image object-cover object-center !hidden xl:!block 2xl:!hidden"
    :imageClass="imageClasses"
    height="900"
    width="768"
    :quality="90"
    @load="emit('load')"
  />
  <SharedPicture
    :media="image"
    :loading="loading"
    :fetchpriority="fetchpriority"
    class="w-full h-full spotlight-image object-cover object-center !hidden 2xl:!block"
    :imageClass="imageClasses"
    height="800"
    width="933"
    :quality="90"
    @load="emit('load')"
  />
</template>

<script lang="ts" setup>
  import type { StrapiMedia } from '~/types/strapi';

  const props = defineProps<{
    image: StrapiMedia;
    mobileImage?: StrapiMedia | null;
    loading: 'lazy' | 'eager';
    fetchpriority: 'auto' | 'high' | 'low';
    imageClass?: string;
  }>();

  const emit = defineEmits<{
    (e: 'load'): void;
  }>();

  const imageClasses = `w-full h-full object-cover object-center block ${props.imageClass || ''}`;
</script>
